/// <amd-module name="VSSUI/Persona" />
export { Persona } from "./Components/Persona/Persona";
export {
    IBasicIdentityRef,
    IIdentity,
    IPersonaProps,
    IPersonaProvider,
    IIdentityDetailsProvider,
    PersonaSize
} from "./Components/Persona/Persona.Props";
